<template>
  <div>Auth bridge ready</div>
</template>

<script>
const ALLOWED_ORIGINS = new Set([
  'http://localhost:19002',
  'http://127.0.0.1:19002',
  'http://localhost:19007',
  'http://127.0.0.1:19007',
])

function getStoredAuthToken() {
  const directToken = window.localStorage.getItem('authToken')
  if (directToken) return directToken

  const persisted = window.localStorage.getItem('vuex-portal')
  if (!persisted) return null

  try {
    const parsed = JSON.parse(persisted)
    return parsed?.authToken || null
  } catch (e) {
    return null
  }
}

export default {
  name: 'AuthBridge',

  mounted() {
    if (process.env.NODE_ENV === 'production') return

    this.handleMessage = (event) => {
      if (!ALLOWED_ORIGINS.has(event.origin)) return
      if (!event.data || event.data.type !== 'REQUEST_AUTH_TOKEN') return

      const token = getStoredAuthToken()
      event.source?.postMessage(
        { type: 'AUTH_TOKEN', token },
        event.origin
      )
    }

    window.addEventListener('message', this.handleMessage)
  },

  beforeDestroy() {
    if (this.handleMessage) {
      window.removeEventListener('message', this.handleMessage)
    }
  },
}
</script>
